import React from "react";
import { Outlet } from "react-router-dom";

const AssociatePartnerRoot = () => {
  return <Outlet />;
};

export default AssociatePartnerRoot;
